import { Store } from "vuex";
import { Plan, BillingInfo } from "../models";

export async function isBilling(store: Store<any>) {
  const { dispatch, getters } = store;
  let billingInfo = getters["billingModule/billingInfo"] as BillingInfo;
  if (billingInfo) {
    return billingInfo.plan !== Plan.free;
  }

  await dispatch("billingModule/fetchBillingInfo");
  billingInfo = getters["billingModule/billingInfo"] as BillingInfo;

  if (!billingInfo) {
    return false;
  }

  return billingInfo.plan !== Plan.free;
}
